import React from "react";
import CountUp from "react-countup";
import { Smile, Target, MapPin, Briefcase } from "lucide-react"; // modern icons
import { motion } from "framer-motion";
import '../index.css';

export default function FactsSection() {
  const facts = [
    {
      icon: <Smile className="w-16 h-16 text-pink-500 drop-shadow-md" />,
      number: 3450,
      label: "Happy Customers",
    },
    {
      icon: <Target className="w-16 h-16 text-blue-500 drop-shadow-md" />,
      number: 2820,
      label: "Hosting Servers",
    },
    {
      icon: <MapPin className="w-16 h-16 text-green-500 drop-shadow-md" />,
      number: 24,
      label: "Locations",
    },
    {
      icon: <Briefcase className="w-16 h-16 text-yellow-500 drop-shadow-md" />,
      number: 54,
      label: "Employees",
    },
  ];

  return (
    <section className="relative bg-gray-50 py-20">
      <div className="container mx-auto px-6">
        <div className="grid grid-cols-2 sm:grid-cols-2 lg:grid-cols-4 gap-10 text-center">
          {facts.map((fact, index) => (
            <motion.div
              key={index}
              initial={{ opacity: 0, y: 40 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.6, delay: index * 0.1 }}
              viewport={{ once: true }}
              className="flex flex-col items-center bg-white rounded-2xl shadow-md p-8 hover:shadow-xl transition-shadow duration-300"
            >
              {fact.icon}
              <strong className="text-4xl font-bold mt-4 mb-2 text-gray-800">
                <CountUp end={fact.number} duration={3} enableScrollSpy scrollSpyOnce />
              </strong>
              <p className="text-gray-600 font-medium">{fact.label}</p>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
}
